var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"order-list-modal-item",on:{"click":function($event){return _vm.$emit('select-item')}}},[_c('span',{staticClass:"item-content"},[_vm._t("default")],2),_c('span',{staticClass:"arrow-icon-container"},[_c('ArrowRight')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }